import React from 'react';
import Logo from './fullLogo.svg?react';

type Props = {
  height?: string | number | undefined;
};

export default function FullLogoIcon({ height }: Props) {
  return <Logo fill={'white'} height={height} />;
}
